import type { TrailDefinition, TrailContext } from './types'

interface HeartParticle {
  x: number
  y: number
  vx: number
  vy: number
  life: number
  maxLife: number
  size: number
  rotation: number
  hue: number
}

const MAX_PARTICLES = 50

function drawHeart(c: CanvasRenderingContext2D, size: number) {
  const s = size
  c.beginPath()
  c.moveTo(0, -s * 0.3)
  c.bezierCurveTo(-s * 0.5, -s, -s, -s * 0.4, 0, s * 0.5)
  c.bezierCurveTo(s, -s * 0.4, s * 0.5, -s, 0, -s * 0.3)
  c.closePath()
}

export const hearts: TrailDefinition = {
  id: 'hearts',
  name: 'Hearts',

  init() {
    return [] as HeartParticle[]
  },

  update(state: unknown, ctx: TrailContext) {
    const particles = state as HeartParticle[]
    const dt = ctx.deltaTime / 1000

    // Spawn hearts at mouse
    if (ctx.mouseActive && dt > 0) {
      const spawnCount = Math.min(2, MAX_PARTICLES - particles.length)
      for (let i = 0; i < spawnCount; i++) {
        const angle = Math.random() * Math.PI * 2
        const speed = 20 + Math.random() * 40
        particles.push({
          x: ctx.mouseX + (Math.random() - 0.5) * 10,
          y: ctx.mouseY + (Math.random() - 0.5) * 10,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 30,
          life: 1,
          maxLife: 0.5 + Math.random() * 0.5,
          size: 4 + Math.random() * 6,
          rotation: (Math.random() - 0.5) * 0.5,
          hue: 330 + Math.random() * 40 // pink to red range
        })
      }
    }

    // Update
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i]
      p.life -= dt / p.maxLife
      p.x += p.vx * dt
      p.y += p.vy * dt
      p.vy -= 15 * dt // float upward
      p.vx *= 0.97

      if (p.life <= 0) {
        particles.splice(i, 1)
      }
    }
  },

  draw(state: unknown, ctx: TrailContext) {
    const particles = state as HeartParticle[]
    const c = ctx.ctx

    for (const p of particles) {
      const alpha = Math.max(0, p.life)
      const scale = 0.5 + alpha * 0.5

      c.save()
      c.translate(p.x, p.y)
      c.rotate(p.rotation)
      c.scale(scale, scale)
      c.globalAlpha = alpha

      drawHeart(c, p.size)
      c.fillStyle = `hsl(${p.hue}, 80%, 65%)`
      c.fill()

      // Soft glow
      c.shadowColor = `hsla(${p.hue}, 90%, 60%, 0.6)`
      c.shadowBlur = p.size * 2
      drawHeart(c, p.size)
      c.fill()

      c.restore()
    }
    c.globalAlpha = 1
  }
}
